import { parseTableSort } from '../../../utils/tableSort';
import { LEAD_SORT_FIELDS, LeadQueryParams } from '../types';

/**
 * Sorting is opt-in: with no `sort_by` in the URL both keys are omitted so the list keeps the
 * server's own priority_tier ordering. Every sortable leads column is a date, so a direction-less
 * URL falls back to newest-first.
 */
export const parseLeadSort = (
    searchParams: URLSearchParams
): Pick<LeadQueryParams, 'sort_by' | 'sort_dir'> => {
    const sort = parseTableSort(searchParams, LEAD_SORT_FIELDS, () => 'DESC');

    return sort ? { sort_by: sort.field, sort_dir: sort.dir } : {};
};
